import { useTranslation } from 'react-i18next';
import { Globe } from '@phosphor-icons/react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { AVAILABLE_LANGUAGES, switchLanguage } from '@/i18n';

/** The interface language. Only languages that have been translated are offered. */
/** `compact`: the header version, a globe and the language code. */
export function LanguagePicker({ compact = false }: { compact?: boolean }) {
  const { t, i18n } = useTranslation();
  if (AVAILABLE_LANGUAGES.length < 2) return null;
  const current = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
  return (
    <Select value={current} onValueChange={(v) => { void switchLanguage(v); }}>
      <SelectTrigger
        className={compact ? 'h-8 w-auto gap-1.5 border-none bg-transparent px-2 text-xs uppercase' : 'h-8 text-xs'}
        aria-label={t('language.label')}
        title={t('language.label')}
      >
        <Globe size={compact ? 16 : 14} className={compact ? 'shrink-0' : 'me-1.5 shrink-0'} />
        {compact ? <span>{current}</span> : <SelectValue />}
      </SelectTrigger>
      <SelectContent>
        {AVAILABLE_LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} className="text-xs">{l.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
